var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paycools-kyc-page" }, [
    _c(
      "section",
      { staticClass: "kyc-content" },
      [
        _c(
          "header",
          { staticClass: "kyc-header" },
          [
            _c(
              "el-button",
              {
                staticStyle: { padding: "0" },
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("requestBack")
                  },
                },
              },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "back",
                    "class-name": "kyc-back-icon",
                  },
                }),
              ],
              1
            ),
            _c("h2", { staticClass: "kyc-title" }, [
              _vm._v(_vm._s(_vm.$t("kyc.title"))),
            ]),
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "signatoryForm",
            staticClass: "kyc-form",
            attrs: {
              model: _vm.form,
              rules: _vm.signatoryRules,
              "label-position": "left",
              "label-width": "260px",
            },
          },
          [
            _vm.rejectionItems && _vm.rejectionItems.length
              ? _c(
                  "div",
                  {
                    staticClass: "kyc-rejection-box",
                    staticStyle: { "margin-bottom": "16px" },
                  },
                  [
                    _c(
                      "el-alert",
                      {
                        attrs: {
                          type: "error",
                          title: _vm.$t("kyc.rejection_title"),
                          closable: false,
                          "show-icon": "",
                        },
                      },
                      _vm._l(_vm.rejectionItems, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "rejection-item" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(index + 1) +
                                ". " +
                                _vm._s(item) +
                                " "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "auth_signatory_name",
                  label: _vm.$t("kyc.signatory_info_legal_name_en"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("kyc.placeholder_enter_name"),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.auth_signatory_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "auth_signatory_name", $$v)
                    },
                    expression: "form.auth_signatory_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "position_id",
                  label: _vm.$t("kyc.signatory_info_position"),
                },
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: _vm.$t("components.select") },
                    model: {
                      value: _vm.form.position_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "position_id", $$v)
                      },
                      expression: "form.position_id",
                    },
                  },
                  _vm._l(_vm.jobList, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label:
                          _vm.language === "zh" ? item.cn_name : item.en_name,
                        value: item.code,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "country_code",
                  label: _vm.$t("kyc.signatory_info_nationality"),
                },
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: _vm.$t("components.select") },
                    model: {
                      value: _vm.form.country_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "country_code", $$v)
                      },
                      expression: "form.country_code",
                    },
                  },
                  _vm._l(_vm.nationalityOptions, function (item) {
                    return _c("el-option", {
                      key: item.code,
                      attrs: {
                        label:
                          _vm.language === "zh" ? item.cn_name : item.en_name,
                        value: item.code,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "id_type",
                  label: _vm.$t("kyc.signatory_info_id_type"),
                },
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: _vm.$t("components.select") },
                    model: {
                      value: _vm.form.id_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "id_type", $$v)
                      },
                      expression: "form.id_type",
                    },
                  },
                  _vm._l(_vm.documentTypeOptions, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "id_number",
                  label: _vm.$t("kyc.signatory_info_id_number"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("kyc.placeholder_enter_id_number"),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.id_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "id_number", $$v)
                    },
                    expression: "form.id_number",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "id_face_photo",
                  label: _vm.$t("kyc.signatory_info_id_photo_front"),
                },
              },
              [
                _c("UpdateFile", {
                  ref: "id_face_photo",
                  attrs: {
                    type: "id_face_photo",
                    "file-list": _vm.fileList,
                    uploading: _vm.uploading,
                    "limit-num": 1,
                    "remove-files": _vm.removeFiles,
                    "uploading-progress": _vm.uploadingProgress,
                  },
                  on: {
                    changeFileList: _vm.changeFileList,
                    changeUploading: _vm.changeUploading,
                    changeUploadingProgress: _vm.changeUploadingProgress,
                    changeRemoveFiles: _vm.changeRemoveFiles,
                  },
                  model: {
                    value: _vm.form.id_face_photo,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "id_face_photo", $$v)
                    },
                    expression: "form.id_face_photo",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "id_back_photo",
                  label: _vm.$t("kyc.signatory_info_id_photo_back"),
                },
              },
              [
                _c("UpdateFile", {
                  ref: "id_back_photo",
                  attrs: {
                    type: "id_back_photo",
                    "file-list": _vm.fileList,
                    uploading: _vm.uploading,
                    "limit-num": 1,
                    "remove-files": _vm.removeFiles,
                    "uploading-progress": _vm.uploadingProgress,
                  },
                  on: {
                    changeFileList: _vm.changeFileList,
                    changeUploading: _vm.changeUploading,
                    changeUploadingProgress: _vm.changeUploadingProgress,
                    changeRemoveFiles: _vm.changeRemoveFiles,
                  },
                  model: {
                    value: _vm.form.id_back_photo,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "id_back_photo", $$v)
                    },
                    expression: "form.id_back_photo",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "authorization_letter",
                  label: _vm.$t("kyc.signatory_info_authorization_letter"),
                },
              },
              [
                _c("UpdateFile", {
                  ref: "authorization_letter",
                  attrs: {
                    type: "authorization_letter",
                    "file-list": _vm.fileList,
                    uploading: _vm.uploading,
                    "limit-num": 1,
                    "remove-files": _vm.removeFiles,
                    "uploading-progress": _vm.uploadingProgress,
                  },
                  on: {
                    changeFileList: _vm.changeFileList,
                    changeUploading: _vm.changeUploading,
                    changeUploadingProgress: _vm.changeUploadingProgress,
                    changeRemoveFiles: _vm.changeRemoveFiles,
                  },
                  model: {
                    value: _vm.form.authorization_letter,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "authorization_letter", $$v)
                    },
                    expression: "form.authorization_letter",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "kyc-footer" },
          [
            _c(
              "el-button",
              {
                staticClass: "kyc-draft-btn",
                attrs: { disabled: _vm.isSubmitting },
                on: { click: _vm.handleSave },
              },
              [_vm._v(_vm._s(_vm.$t("kyc.save_as_draft")))]
            ),
            _c(
              "el-button",
              {
                staticClass: "kyc-next-btn",
                attrs: { type: "primary", disabled: _vm.isSubmitting },
                on: { click: _vm.handleNext },
              },
              [_vm._v(_vm._s(_vm.$t("kyc.next_step")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }